import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import styles from './OpsCenterView.module.less';

type OpsCenterLinkProps = {
  to: string;
  icon: IconProp;
  className?: string;
  iconClassName?: string;
  children: ReactNode;
};

const OpsCenterLink: React.FC<OpsCenterLinkProps> = ({ to, icon, className, iconClassName, children }) => {
  return (
    <Link to={to} className={clsx(styles.opsCenterLink, className)}>
      <span className={styles.opsCenterIconWrapper}>
        <FontAwesomeIcon icon={icon} className={clsx(styles.opsCenterIcon, iconClassName)} size={'lg'} />
      </span>
      {children}
    </Link>
  );
};

export default OpsCenterLink;
